import React from "react";
import BreedCardCarousel from "../../../components/BreedCardCarousel/BreedCardCarousel";
import WrappedSection from "../../WrappedSection/WrappedSection";
import * as styles from "./SectionBreedCarousel.module.scss";

export interface SectionBreedCarouselProps {
	heading: string;
	htmlText: string;
	items: Queries.BreedContentDataFragment[];
	jumpLinksTitle?: string;
}

export const getSectionBreedCarouselProps = ({
	field_front_end_title,
	field_section_short_description,
	field_jump_links_title,
}: Queries.SectionDataFragment) => ({
	heading: field_front_end_title,
	htmlText: field_section_short_description?.value,
	jumpLinksTitle: field_jump_links_title,
});
export const SectionBreedCarousel: React.FC<SectionBreedCarouselProps> = ({
	heading,
	htmlText,
	items,
	jumpLinksTitle,
}) => {
	return (
		<WrappedSection sectionName="SectionBreedCarousel">
			<div className={styles.breedcarouselinner}>
				{jumpLinksTitle ? (
					<h2 data-jumplinkstitle={jumpLinksTitle}>{heading}</h2>
				) : (
					<h2>{heading}</h2>
				)}
				<div
					className={styles.textWrapper}
					// biome-ignore lint/security/noDangerouslySetInnerHtml: Safe source
					dangerouslySetInnerHTML={{
						__html: htmlText,
					}}
				/>
				<BreedCardCarousel breeds={items} />
			</div>
		</WrappedSection>
	);
};

export default SectionBreedCarousel;
